import {Component} from '@angular/core';
import {PropertyListInformationDto} from "../../dto/property.list.information.dto";
import {PropertyService} from "../../services/property.service";
import {UserService} from "../../services/user.service";
import {RecordStageRoute} from "../../dto/record.stage.route";
import {Router} from "@angular/router";
import {RecordStageEnum} from "../../dto/enum/record.stage.enum";
import {PropertyInitialSubject} from "../../subject/property.initial.subject";
import {Observable, tap, throwError} from "rxjs";
import {PropertyInitialResponseDto} from "../../dto/property.initial.response.dto";
import {catchError} from "rxjs/operators";
import {FlowStateService} from "../../services/flow.state.service";
import {FlowModeSubject} from "../../subject/flow.mode.subject";
import {FlowMode} from "../../dto/enum/flow.mode.enum";

@Component({
    selector: 'app-property-list-pending',
    templateUrl: './property-list-pending.component.html',
    styleUrls: ['./property-list-pending.component.scss']
})
export class PropertyListPendingComponent {

    properties: PropertyListInformationDto[] = [];
    userName: string = '';
    offset: number = 0;
    pagezise: number = 6;
    loadButtonMore: boolean = false;
    stage: RecordStageEnum | undefined;

    constructor(
        private propertyService: PropertyService,
        private accountService: UserService,
        private router: Router,
        private propertyInitialSubject: PropertyInitialSubject,
        private flowStateService: FlowStateService,
        private flowModeSubject: FlowModeSubject
    ) {}

    ngOnInit() {
        this.loadUserData();
        this.loadProperties();
    }

    loadUserData() {
        this.accountService.getUserInfo().subscribe(response => {
            if (response) {
                this.userName = response.accountName;
            }
        });
    }

    loadProperties() {
        this.propertyService.getProperties('PENDING_PROP',this.offset, this.pagezise).subscribe(response => {
            if (response) {
                this.properties = response.content;
                console.log(response);
                console.log('properties', this.properties);
                if(response.totalElements > 6){
                    this.loadButtonMore = true;
                }

            }
        });
    }

    editProperty(property: PropertyListInformationDto) {
        console.log('Editar propiedad:', property);

        this.getPropertyInitialData(property.propertyId)
            .subscribe({
                next: (response) => {
                    console.log('Respuesta de datos iniciales:', response);

                    const stage = response?.recordStage as RecordStageEnum;
                    if (!stage) {
                        console.warn('Stage inválido:', stage);
                        return;
                    }

                    // Paso destino a partir del stage
                    const step = this.flowStateService.getStepByRecordStage(stage);
                    if (!step) {
                        console.warn('No se pudo resolver el paso a partir del stage:', stage);
                        return;
                    }

                    // 💾 Hidratar estado de flujo
                    this.flowStateService.setRecordStage(stage);
                    this.flowStateService.setPropertyId(response.propertyId);
                    this.flowStateService.setCurrentStep(step);

                    // 💡 Modo de flujo: al “continuar” conviene RESUME (o EDIT si NO quieres avanzar etapas)
                    this.flowModeSubject.setMode(FlowMode.RESUME);

                    // ✅ Navegar
                    this.router.navigate([`/${step}`]); // o this.router.navigateByUrl(`/${step}`)
                },
                error: (err) => console.error('Error cargando propiedad:', err)
            });
    }


    loadMore() {
        this.pagezise += 6;
        this.loadProperties();
    }

    isMobile() {
        return window.innerWidth <= 1024;
    }

    getPropertyInitialData(propertyId: number): Observable<PropertyInitialResponseDto> {
        return this.propertyService.getPropertyInitialData(propertyId).pipe(
            tap((response) => {
                if (response) {
                    console.log('Datos iniciales de la propiedad:', response);
                    this.propertyInitialSubject.updateProperty(response);
                }
            }),
            catchError((error) => {
                console.error('Error al obtener los datos iniciales de la propiedad:', error);
                return throwError(() => error);
            })
        );
    }

}
